import React from "react";

import { withRouter } from "../../boot/hooks/useRouter";
import { Switch } from "react-router-dom";
import PrivateRoute from "../../boot/PrivateRoute";

import Resume from "../../components/Event/Resume";
import Settings from "../../components/Event/Settings";
import CustomPlayer from "../../components/Event/CustomPlayer";
import Subscribers from "../../components/Event/Subscribers";
import Recording from "../../components/Event/Recording";
import NewEventContainer from "../../screens/NewEvent/NewEventContainer";
import Survey from "../../components/Event/Survey";
import NewSurvey from "../../components/Event/NewSurvey";
import Viewers from "../../components/Event/Viewers";
import Report from "../../components/Event/Report";
import Restreaming from "../../components/Event/Restreaming";
import SatisfactionSurvey from "../../components/Event/SatisfactionSurvey";

import TabButton from "./TabButton";

import MyBrand from "../../screens/MyBrand";

import I18n from "../../locales/i18n";

const EventView = ({
  packageDetails,
  state,
  status,
  tabs,
  tabActive,
  onChangeTab,
  onChangeImage,
  onDeleteImage,
  onCustomPlayer,
  onUpdateDoc,
  getEventData,
  docRef,
  videoServer,
  id,
  event,
  props,
}) => {
  const {
    whiteBrand = false,
    report = false,
    restreaming = false,
    maxRestreaming = 0,
    maxCustomFields = 0,
    transcoder = false,
    feedback = false,
  } = packageDetails;

  return (
    <div>
      <div className="az-content-header">
        <div className="az-content-header-top">
          <div>
            <h2 className="az-content-title mg-b-5 mg-b-lg-8">{state.name}</h2>
            <p className="mg-b-0">{state.short_description}</p>
          </div>
          <div className="az-dashboard-date">
            <div className="date">
              <div>{state.startDate.format("DD")}</div>
              <div>
                <span>{state.startDate.format("MMM YYYY")}</span>
                <span>{state.startDate.format("HH:mm")}</span>
              </div>
            </div>
            <i className="fas fa-arrow-right"></i>
            <div className="date">
              <div>{state.endDate.format("DD")}</div>
              <div>
                <span>{state.endDate.format("MMM YYYY")}</span>
                <span>{state.endDate.format("HH:mm")}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="az-content-header-top">
          <h1 className={"text-center event-status " + status.value}>
            {I18n("EVENTS", status.value)}
          </h1>
        </div>
        <div className="nav-wrapper">
          <nav className="nav az-nav-line">
            <TabButton
              onClick={(e) => {
                onChangeTab(e, tabs.RESUME);
              }}
              path={"./resume"}
              isActive={tabActive === tabs.RESUME}
              text={I18n("EVENTS", "RESUME")}
            />
            <TabButton
              onClick={(e) => {
                onChangeTab(e, tabs["CUSTOM-PLAYER"]);
              }}
              path={"./custom-player"}
              isActive={tabActive === tabs["CUSTOM-PLAYER"]}
              text={I18n("EVENTS", "PLAYER")}
            />
            {whiteBrand && (
              <TabButton
                onClick={(e) => {
                  onChangeTab(e, tabs["CUSTOM_BRAND"]);
                }}
                path={"./custom-brand"}
                isActive={tabActive === tabs["CUSTOM_BRAND"]}
                text={I18n("EVENTS", "BRAND")}
              />
            )}
            <TabButton
              onClick={(e) => {
                onChangeTab(e, tabs.SETTINGS);
              }}
              path={"./settings"}
              isActive={tabActive === tabs.SETTINGS}
              text={I18n("EVENTS", "SETTINGS")}
            />
            {restreaming && (
              <TabButton
                onClick={(e) => {
                  onChangeTab(e, tabs["RESTREAMING"]);
                }}
                path={"./restreaming"}
                isActive={tabActive === tabs["RESTREAMING"]}
                text={I18n("EVENTS", "RESTREAMING")}
              />
            )}
            {state.privacity === "PRIVATE" && (
              <TabButton
                onClick={(e) => {
                  onChangeTab(e, tabs.SUBSCRIBERS);
                }}
                path={"./subscribers"}
                isActive={tabActive === tabs.SUBSCRIBERS}
                text={I18n("EVENTS", "SUBSCRIBERS")}
              />
            )}
            {state.privacity === "PRIVATE" && event.record_viewer === "true" && (
              <TabButton
                onClick={(e) => {
                  onChangeTab(e, tabs.VIEWERS);
                }}
                path={"./viewers"}
                isActive={tabActive === tabs.VIEWERS}
                text={I18n("EVENTS", "VIEWERS_LOG")}
              />
            )}
            <TabButton
              onClick={(e) => {
                onChangeTab(e, tabs.SURVEYS);
              }}
              path={"./surveys"}
              isActive={tabActive === tabs.SURVEYS}
              text={I18n("EVENTS", "SURVEYS")}
            />
            {status.code >= 2 && (
              <TabButton
                onClick={(e) => {
                  onChangeTab(e, tabs.RECORDING);
                }}
                path={"./recording"}
                isActive={tabActive === tabs.RECORDING}
                text={I18n("EVENTS", "RECORDING")}
              />
            )}
            {feedback && (
              <TabButton
                onClick={(e) => {
                  onChangeTab(e, tabs["FEEDBACK"]);
                }}
                path={"./feedback"}
                isActive={tabActive === tabs["FEEDBACK"]}
                text={I18n("EVENTS", "FEEDBACK")}
              />
            )}
            {status.code >= 2 && report && (
              <TabButton
                onClick={(e) => {
                  onChangeTab(e, tabs.REPORT);
                }}
                path={"./report"}
                isActive={tabActive === tabs.REPORT}
                text={I18n("EVENTS", "REPORT")}
              />
            )}

            <TabButton
              onClick={(e) => {
                onChangeTab(e, tabs.EDIT);
              }}
              path={"./edit"}
              isActive={tabActive === tabs.EDIT}
              text={I18n("EVENTS", "EDIT")}
              t
            />
          </nav>
        </div>
      </div>
      <div className="az-content-body">
        <Switch>
          <PrivateRoute
            path="/event/:eid/edit"
            component={NewEventContainer}
            authenticated={true}
            trackEvent={props.trackEvent}
            eventStatus={status}
            currentUser={props.currentUser}
            onRequestLoading={props.onRequestLoading}
            isEditing={true}
            isLoading={props.isLoading}
            docRef={docRef}
            event={event}
          />

          <PrivateRoute
            path="/event/:eid/custom-player"
            component={CustomPlayer}
            authenticated={true}
            currentUser={props.currentUser}
            onRequestLoading={props.onRequestLoading}
            timestamp={state.timestamp}
            isEditing={true}
            onChangeImage={onChangeImage}
            onDeleteImage={onDeleteImage}
            onCustomPlayer={onCustomPlayer}
            firebase={props.firebase}
            event={event}
            isLoading={props.isLoading}
          />
          {whiteBrand && (
            <PrivateRoute
              path="/event/:eid/custom-brand"
              component={MyBrand}
              authenticated={true}
              alert={true}
              currentUser={props.currentUser}
              onRequestLoading={props.onRequestLoading}
              folder={`events/${event.id}/brand`}
              collection={"events"}
              bd={event}
              uid={event.id}
            />
          )}

          <PrivateRoute
            path="/event/:eid/settings"
            component={Settings}
            authenticated={true}
            currentUser={props.currentUser}
            onRequestLoading={props.onRequestLoading}
            isEditing={true}
            firebase={props.firebase}
            isLoading={props.isLoading}
            docRef={docRef}
            onUpdateDoc={onUpdateDoc}
            getEventData={getEventData}
            helpers={props.helpers}
            event={event}
          />

          {state.privacity === "PRIVATE" && (
            <PrivateRoute
              path="/event/:eid/subscribers"
              component={Subscribers}
              authenticated={true}
              currentUser={props.currentUser}
              onRequestLoading={props.onRequestLoading}
              isEditing={true}
              maxCustomFields={maxCustomFields}
              isLoading={props.isLoading}
              docRef={docRef}
              firebase={props.firebase}
              event={event}
            />
          )}

          {status.code >= 2 && (
            <PrivateRoute
              path="/event/:eid/recording"
              component={Recording}
              eventStatus={status}
              authenticated={true}
              event={event}
              currentUser={props.currentUser}
              onRequestLoading={props.onRequestLoading}
            />
          )}

          {feedback && (
            <PrivateRoute
              path="/event/:eid/feedback"
              component={SatisfactionSurvey}
              eventStatus={status}
              authenticated={true}
              event={event}
              currentUser={props.currentUser}
              firebase={props.firebase}
              onRequestLoading={props.onRequestLoading}
            />
          )}

          <PrivateRoute
            exact
            path="/event/:eid/surveys"
            component={Survey}
            authenticated={true}
            currentUser={props.currentUser}
            onRequestLoading={props.onRequestLoading}
            firebase={props.firebase}
            event={event}
          />

          <PrivateRoute
            exact
            path="/event/:eid/new-survey"
            component={NewSurvey}
            authenticated={true}
            currentUser={props.currentUser}
            firebase={props.firebase}
            onRequestLoading={props.onRequestLoading}
            event={event}
          />

          <PrivateRoute
            exact
            path="/event/:eid/viewers"
            component={Viewers}
            authenticated={true}
            currentUser={props.currentUser}
            firebase={props.firebase}
            onRequestLoading={props.onRequestLoading}
            event={event}
          />

          {report && (
            <PrivateRoute
              exact
              path="/event/:eid/report"
              component={Report}
              authenticated={true}
              currentUser={props.currentUser}
              firebase={props.firebase}
              onRequestLoading={props.onRequestLoading}
              event={event}
            />
          )}

          {restreaming && (
            <PrivateRoute
              exact
              path="/event/:eid/restreaming"
              component={Restreaming}
              authenticated={true}
              currentUser={props.currentUser}
              firebase={props.firebase}
              onRequestLoading={props.onRequestLoading}
              videoServer={videoServer}
              maxRestreaming={maxRestreaming}
              transcoder={transcoder}
              eid={id}
              event={event}
            />
          )}

          <PrivateRoute
            component={Resume}
            eventStatus={status}
            authenticated={true}
            event={event}
            currentUser={props.currentUser}
            onRequestLoading={props.onRequestLoading}
          />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(EventView);
